/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.state';

const selectAuthState = createFeatureSelector<AuthState>('auth');
export const isAuthInitialized = createSelector(selectAuthState, state => state.authInit);
export const isAuthenticated = createSelector(selectAuthState, state => state.authenticated);
export const isAuthenticationPending = createSelector(selectAuthState, state => state.pending);
export const authenticationError = createSelector(selectAuthState, state => state.error);
export const currentUser = createSelector(selectAuthState, state => state.user);
